import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'
import Flex from 'components/Flex'
import IconArrow from 'components/Icons/IconArrow'
import { colors } from 'theme/default'

const NakedButton = styled.button.attrs(() => ({
  type: 'button' // To prevent form submit when DatePicker is placed inside a form
}))`
  border: none;
  box-shadow: none;
  background: transparent;
  font-size: 1em;
  outline: 0;
  cursor: pointer;
  padding: 0;
  ${props => props.block ? `
    width: 100%;
    display: block;
  ` : ''}
`

const NavBarContainer = styled(Flex).attrs(() => ({
  justifyContent: 'space-between'
}))`
  position: absolute;
  pointer-events: none;
  width: 100%;
  color: ${colors.text};
  height: 2.5em;
  ${breakpoint('desktop')`
    height: 3.5em;
  `}
`

const StyledNakedButton = styled(NakedButton)`
  pointer-events: all;
  opacity: ${props => props.blur ? 0.2 : 1};
  cursor: ${props => props.blur ? 'default' : 'pointer'};
`
StyledNakedButton.propTypes = {
  blur: PropTypes.bool
}

const NavBar = ({ fromMonth, toMonth, previousMonth, nextMonth, onPreviousClick, onNextClick }) => (
  <NavBarContainer>
    <StyledNakedButton data-testid='datePicker.prevButton' onClick={() => onPreviousClick()} blur={previousMonth < fromMonth.setHours(12)}>
      <IconArrow.Left fill={colors.text} />
    </StyledNakedButton>
    <StyledNakedButton data-testid='datePicker.nextButton' onClick={() => onNextClick()} blur={toMonth.setHours(12) < nextMonth}>
      <IconArrow.Right fill={colors.text} />
    </StyledNakedButton>
  </NavBarContainer>
)
NavBar.propTypes = {
  fromMonth: PropTypes.instanceOf(Date).isRequired, // injected by react-day-picker
  toMonth: PropTypes.instanceOf(Date).isRequired, // injected by react-day-picker
  previousMonth: PropTypes.instanceOf(Date), // injected by react-day-picker
  nextMonth: PropTypes.instanceOf(Date), // injected by react-day-picker
  onPreviousClick: PropTypes.func, // injected by react-day-picker
  onNextClick: PropTypes.func // injected by react-day-picker
}

export default NavBar
